import defaultState from '../rangeData/rangeDataDefaultState';
import { Action } from '../../generalTypes';
import { RangeData } from './rangeDataTypes';
import { SET_RANGE_DATA } from '../actionConstants';

export default (state: RangeData = defaultState, action: Action<RangeData>) => {
  switch (action.type) {
    case SET_RANGE_DATA:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    default:
      return state;
  }
};
